// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"630":"d205c8330b40621c3a04","3169":"b94ac7494fcee0766a2a"}[chunkId] + ".js";
};